<ng-container *ngFor="let item of bannerData">

<div class="SLV2-page-banner-box hdr-collaps {{bannerSubject?.replace(' ','') | lowercase}}"
    [ngClass]="{'noicon' : getSubjectIconName(bannerSubject?.replace(' ','') | lowercase) == 'selflearnv2-ui/assets/img/subject-icons/default_subject_icon'}">

    <ng-container *ngTemplateOutlet="sayHelloTemplate"></ng-container>

</div>



<div class="SLV2-page-banner-box normal {{bannerSubject?.replace(' ','') | lowercase}}" id="pageHeaderBanner1"  [ngClass]="{'noicon' : getSubjectIconName(bannerSubject?.replace(' ','') | lowercase) == 'selflearnv2-ui/assets/img/subject-icons/default_subject_icon'}">
    
    <ng-container *ngTemplateOutlet="sayHelloTemplate"></ng-container>
    
</div>







<ng-template #sayHelloTemplate>
    <div class="SLV2-page-banner-innr">
        <div class="SLV2-banner-left-col">
    
            <button class="SLV2-page-banner-button">
                <img (click)="navigateToSelfLearnHome()"
                    src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                <span class="button-text">
                    <ng-container *ngIf="item.bannerTitle !=''">{{item?.bannerTitle}}</ng-container>
                    <ng-container *ngIf="item.bannerTitle ==''">{{SelctedBookName ? SelctedBookName:
                        bannerSubject}}</ng-container>
                </span>
            </button>
            <!-- {{bannerData | json}}<br> -->
            <div class="SLV2-page-banner-info-area">
                <h4 class="SLV2-page-banner-title">
                    <ng-container *ngIf="item.bannerTitle !=''">{{item?.bannerTitle}}</ng-container>
                    <ng-container *ngIf="item.bannerTitle ==''">{{SelctedBookName ? SelctedBookName:
                        bannerSubject}}</ng-container>
                </h4>
                <h5 class="SLV2-page-banner-subtitle" *ngIf="item?.chapterCount">{{item?.chapterCount}} {{isTopicsHeader?
                    item?.chapterCount==1?'Topic':'Topics':item?.chapterCount ==1 ? 'Chapter':'Chapters'}}</h5>
                <!-- <div class="SLV2-page-banner-graytext" *ngIf="item?.chapterLession">
                            <img src="assets/img//self-learn-v2/book-icon.svg" class="icon-img" />
                            <span>{{item?.chapterLession}}</span>
                            <img src="assets/img//self-learn-v2/down-arrow-icon.svg" class="arrow-icon" />
                        </div> -->
                <div class="SLV2-banner-progressbar-wrap" *ngIf="item?.progress >=0"
                    [ngClass]="{'success':item?.progress == 100}">
                    <div class="SLV2-banner-progressbar">
                        <span [style.width]="item?.progress+'%'"></span>
                    </div>
                    <span>{{item?.progress | number: '1.0-0'}}%</span>
                </div>
            </div>
        </div>
        <div class="SLV2-banner-right-col">
            <!-- <div class="SLV2-bnnr-icnic-optn">
                    <button class="SLV2-bnnr-icnic-btn">
                        <img src="assets/img/self-learn-v2/search-icon.svg" class="SLV2-bnnr-icnic-btn-img" />
                    </button>
                </div>
                <div class="SLV2-bnnr-icnic-optn">
                    <button class="SLV2-bnnr-icnic-btn">
                        <img src="assets/img/self-learn-v2/calendar-icon.svg" class="SLV2-bnnr-icnic-btn-img" />
                    </button>
                </div> -->
        </div>
    </div>
    
    <div class="SLV2-banner-subject-icon-wrap">
        <img [src]="getSubjectIcon(bannerSubject?.replace(' ','') | lowercase)" class="SLV2-banner-subject-icon"
            *ngIf="getSubjectIconName(bannerSubject?.replace(' ','') | lowercase) != 'selflearnv2-ui/assets/img/subject-icons/default_subject_icon'" />
        <img src="selflearnv2-ui/assets/img/subject-icons/default_subject_icon.svg" class="SLV2-banner-subject-icon noicon"
            *ngIf="getSubjectIconName(bannerSubject?.replace(' ','') | lowercase) == 'selflearnv2-ui/assets/img/subject-icons/default_subject_icon'" />
    
    </div>
</ng-template>



</ng-container>

